import React from "react";
import PropTypes from "prop-types";

import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from "../../../global/imagenes/emma_w.png";

/** Bandeja sin resultados. */
export const EstadoVacio = ({ mensaje }) => (
  <TareasTerminadas
    imagen={emma_w}
    mensaje={mensaje}
    widthImg="10%"
    marginTop="10%"
  />
);

EstadoVacio.propTypes = { mensaje: PropTypes.string.isRequired };

/** Espera mientras responde el API. */
export const Cargando = () => (
  <TareasTerminadas
    mensaje="Cargando..."
    marginTop="7%"
    imagen={emma_w}
    widthImg="7%"
    cargando
  />
);
